// Single source of truth for the app version.
// Keep in sync with package.json when bumping versions.
// REACT_APP_BUILD_TARGET is injected at build time by the deploy workflow
// (e.g. 'demo', 'maxiv') and appended as a suffix so each deployment is
// identifiable in the UI without any branch-specific version management.
export const APP_VERSION = '3.14.0';
const BUILD_TARGET = process.env.REACT_APP_BUILD_TARGET || '';
export const APP_VERSION_FULL = BUILD_TARGET ? `${APP_VERSION}-${BUILD_TARGET}` : APP_VERSION;
